import badminton from "../../../assets/img/img-animations/01_badminton_480_320.png";
import venteFromageVin from "../../../assets/img/img-animations/02_venteFromageVin_480x320.png";
import tournoiInterne from "../../../assets/img/img-animations/04_tennis-raquettes_480X320.png";
import assembleeGenerale from "../../../assets/img/img-news/ag/ag-2026-tcf-450x300.png";
import pickleball from "../../../assets/img/img-animations/06_pickleball_480X320.png";
// import soireeClub from "../../../assets/img/img-animations/08_soireeClub_480x320.png";
// import bannerTmc from "../../../assets/img/img-news/Banner-TMC-TCF-450x300.png";
import bonneAnnee from "../../../assets/img/img-news/bonneannee2026-450x300.png";
// import rolandGarros from "../../../assets/img/img-animations/09_rolandGarros.png";
import inscriptions2027 from "../../../assets/img/img-news/Inscriptions/2027_Affiche inscription-450x300.png";
// import inscriptions20251 from "../../../assets/img/img-news/adhesionJeunes1.jpg";
// import inscriptions20252 from "../../../assets/img/img-news/adhesionJeunes2.jpg";
// import retardataires from "../../../assets/img/img-news/retardataire-450x300.png";
import repriseCours from "../../../assets/img/img-news/repriseCours-450x300.png";
// import jumelage from "../../../assets/img/img-animations/13-jumelage-1000x563.jpg";
// import octobreRose from "../../../assets/img/img-octobrerose/imgOctobreRose-2024-02-1068x632.jpeg";

const tabActivitesClub = [
  {
    id: 0,
    image: inscriptions2027,
    animation: "Adhésions 2027",
    desc: "Les insciptions sont ouvertes !!",
    dateDebut: "2026-08-22",
    dateFin: "2026-10-31",
    lieu: "Clubhouse",
    link: "/contact",
  },
  {
    id: 1,
    image: repriseCours,
    animation: "Reprise des cours",
    desc: "Les cours débuteront le lundi 14/9",
    dateDebut: "2026-09-14",
    dateFin: "2027-07-01",
    lieu: "Courts extérieurs ou couverts",
    link: "/contact",
  },
  // {
  //   id: 0,
  //   image: retardataires,
  //   animation: "Adhésions",
  //   desc: "Contacter le moniteur ou un membre du bureau",
  //   dateDebut: "2025-09-01",
  //   dateFin: "2025-10-31",
  //   lieu: "Moniteur ou membre du bureau",
  //   link: "/contact",
  // },
  {
    id: 2,
    image: tournoiInterne,
    animation: "Championnats par équipes SENIORS+",
    desc: "35+ 1 équipe Dames et 1 équipe Messieurs, 55+ 1 équipe Messieurs.",
    dateDebut: "2026-10-04",
    dateFin: "2026-11-08",
    lieu: "Courts extérieurs ou couverts",
    link: "/competitions/schampt",
  },
  {
    id: 3,
    image: assembleeGenerale,
    animation: "Assemblée Générale",
    desc: "En tant que membres du club vous êtes conviés. Venez nombreux ...",
    dateDebut: "2026-10-23",
    dateFin: "2026-10-23",
    lieu: "Clubhouse de 19h à 20h",
    link: "#",
  },
  // {
  //   id: 2,
  //   image: octobreRose,
  //   animation: "Octobre Rose",
  //   desc: "Après-midi détente réservée aux Dames au profit de - Les Fées Papillons - association de lutte contre le cancer ...",
  //   dateDebut: "2024-10-19",
  //   dateFin: "2024-10-19",
  //   lieu: "Courts couverts",
  //   link: "/animations/octobreRose",
  // },
  {
    id: 4,
    image: pickleball,
    animation: "Pickleball",
    desc: "Journée détente en pratiquant une activité accessible à tous ...",
    dateDebut: "2026-11-21",
    dateFin: "2026-11-21",
    lieu: "Courts couverts",
    link: "/animations/pickleball",
  },
  // {
  //   id: 4,
  //   image: soireeClub,
  //   animation: "Repas de fin d'année",
  //   desc: "Tous les membres intéressés sont invités. Faites-vous connaître ...",
  //   dateDebut: "2026-02-16",
  //   dateFin: "2026-02-16",
  //   lieu: "Clubhouse",
  //   link: "/animations/soireeclub",
  // },
  {
    id: 5,
    image: venteFromageVin,
    animation: "Vente de Fromages du Jura - Vins du Beaujolais",
    desc: "Commandes de Noël à passer avant le 30 novembre. Distribution le 19 décembre.",
    dateDebut: "2026-12-19",
    dateFin: "2026-12-19",
    lieu: "Maison de quartier",
    link: "/animations/ventes",
  },
  {
    id: 6,
    image: bonneAnnee,
    animation: "BONNE ANNÉE 2027",
    desc: "Le TCF vous souhaite une très BONNE ANNÉE 2027.",
    dateDebut: "2027-01-01",
    dateFin: "2027-01-31",
    lieu: "",
    link: "#",
  },
  // {
  //   id: 6,
  //   image: tournoiInterne,
  //   animation: "Doubles de Noël",
  //   desc: "Compétition amicale avec changement de partenaire à chaque double ...",
  //   dateDebut: "2025-12-26",
  //   dateFin: "2026-01-03",
  //   lieu: "Courts couverts",
  //   link: "/competions",
  // },
  {
    id: 7,
    image: pickleball,
    animation: "Tournoi de Pickleball",
    desc: "Journée détente en pratiquant une activité accessible à tous ...",
    dateDebut: "2027-01-30",
    dateFin: "2027-01-30",
    lieu: "Courts couverts",
    link: "/animations/pickleball",
  },
  {
    id: 8,
    image: badminton,
    animation: "Tournoi de Badminton",
    desc: "Tournoi de la St Patrick - Ouvert à tous. Venez nombreux avec vos amis ...",
    dateDebut: "2027-03-20",
    dateFin: "2027-03-20",
    lieu: "Salle polyvalente",
    link: "/animations/badminton",
  },
  {
    id: 9,
    image: venteFromageVin,
    animation: "Vente de Fromages du Jura - Vins du Beaujolais",
    desc: "Commandes à passer avant le 13 mars ...",
    dateDebut: "2027-03-27",
    dateFin: "2027-03-27",
    lieu: "Clubhouse",
    link: "/animations/ventes",
  },
  {
    id: 10,
    image: tournoiInterne,
    animation: "Championnats par équipes SENIORS",
    desc: "2 équipes Dames et 4 équipes Messieurs.",
    dateDebut: "2027-04-25",
    dateFin: "2027-06-06",
    lieu: "Courts extérieurs ou couverts",
    link: "/competitions/schampt",
  },
  {
    id: 11,
    image: tournoiInterne,
    animation: "42ème Tournoi de Tennis - NC à 4/6",
    desc: "Les insciptions se feront via TEN'UP à partir du 01/01/2027.",
    dateDebut: "2027-06-11",
    dateFin: "2027-06-27",
    lieu: "Courts extérieurs ou couverts",
    link: "/competitions/stournoi",
  },
  // {
  //   id: 7,
  //   image: soireeClub,
  //   animation: "Fête du Tennis Club",
  //   desc: "Repas de fin d'année entre membres et amis du club ...",
  //   dateDebut: "2026-07-04",
  //   dateFin: "2026-07-04",
  //   lieu: "Clubhouse",
  //   link: "/animations/soireeclub",
  // },
  // {
  //   id: 10,
  //   image: jumelage,
  //   animation: "Jumelage TC Bad Waldsee",
  //   desc: "WE convivial avec nos amis allemands du TC de Bad Waldsee ...",
  //   dateDebut: "2025-07-27",
  //   dateFin: "2025-07-29",
  //   lieu: "Courts extérieurs et couverts",
  //   link: "/events/jumelage",
  // },
  // {
  //   id: 12,
  //   image: bannerTmc,
  //   animation: "TMC - Tournoi Multi-Chances",
  //   desc: "Tournoi interne sur une journée le dimanche 19 ou 26/1 ou 2 ou 23/2. Réservé aux 30/1 et moins.",
  //   dateDebut: "2025-01-19",
  //   dateFin: "2025-02-23",
  //   lieu: "Courts couverts",
  //   link: "#",
  // },

  // {
  //   id: 11,
  //   image: tournoiInterne,
  //   animation: "Tournoi interne",
  //   desc: "Les inscriptions doivent se faire sur TEN'UP au plus tard le 15/03/2026.",
  //   dateDebut: "2026-04-01",
  //   dateFin: "2026-06-30",
  //   lieu: "Courts extérieurs ou couverts",
  //   link: "/competitions",
  // },
];

export default tabActivitesClub;
